import { render, staticRenderFns } from "./ContractAddCommentDialog.vue?vue&type=template&id=663d1021&"
import script from "./ContractAddCommentDialog.vue?vue&type=script&lang=js&"
export * from "./ContractAddCommentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports